//Vue 2.6.11
import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import babelPolyfill from 'babel-polyfill'
import axios from 'axios'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import AuthService from './services/AuthService.js'
import AuthApiService from './services/AuthApiService.js'
import VueCryptojs from 'vue-cryptojs'
import Vuelidate from "vuelidate"
import { CoolSelectPlugin } from "vue-cool-select"
//import VueMask from 'v-mask'
import VueSwal from 'vue-swal'
import VueMoment from 'vue-moment'
import moment from 'moment'
import NotificationService from './services/NotificationService'
import VFIService from './services/VFIService'

require('moment/locale/es')

library.add(fab)
library.add(fas)
Vue.config.performance = true

// Registrar componentes globalmente
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('pagination', require('./components/PaginationComponent.vue').default);
Vue.component('alert-sin-resultados', require('./components/AlertSinResultados.vue').default);
Vue.component('alert-exito', require('./components/AlertExito.vue').default);
Vue.component('alert-error', require('./components/AlertError.vue').default);
Vue.component('alert-advertencia', require('./components/AlertAdvertencia.vue').default);
Vue.component('alert-info', require('./components/AlertInfo.vue').default);
Vue.use(CoreuiVue);
Vue.use(VueCryptojs);
Vue.use(Vuelidate);
Vue.use(CoolSelectPlugin);
//Vue.use(VueMask);
Vue.use(VueSwal);
Vue.use(VueMoment, { moment });
Vue.prototype.$log = console.log.bind(console)
Vue.prototype.$axios = axios
Vue.prototype.$AuthService = new AuthService();
Vue.prototype.$AuthApiService = new AuthApiService();
Vue.prototype.$notificationService = new NotificationService();
Vue.prototype.$VFIService = new VFIService();


new Vue({
  el: '#app',
  router,
  store,
  icons,
  babelPolyfill,
  template: '<App/>',
  components: {
    App
  }
})
